<template>
    <div id="container" type="vdpp">
        <div class="page page-dap" v-ga:page="{pageType: glb.pageType, glb: glb}" v-ga:request="{pageType:'vdap'}">
            <mvtHeader />
            <div class="static-gs">
                <agentNav/>
            </div>
            <div class="static-section">
                <div class="static-gs gs-md-fix">
                    <dapInfo></dapInfo>
                    <div>
                        <div class="inline large corner bg-default">
                            <mvtHotleadForm :options="hotleadOpt"></mvtHotleadForm>
                        </div>
                    </div>
                </div>
            </div>
            <div class="static-section" v-if="dap.transactionSummary && dap.transactionSummary.length > 0">
                <div class="static-gs gs-md-fix">
                    <agentTransaction :transactions="dap.transactionSummary"></agentTransaction>
                   <div>
                       <div class="dap-notice">
                           <div><b class="f4">{{dap.firstName}}'s Neighborhood Insights</b></div>
                           <div>Learn about the neighborhood from {{dap.firstName}} based on their experience in {{dap.geo.city}}, {{dap.geo.state}}.</div>
                            <template v-if="dap.neighborhoodInfo && dap.neighborhoodInfo.length ">
                                <div class="list">
                                    <template v-for="item in dap.neighborhoodInfo">
                                        <i class="dap-poi" :class="item.type"></i>
                                        <div>
                                            <div class="f7">
                                                {{item.title}}
                                            </div>
                                            <div class="text-bold">
                                                {{item.value}}
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </template>
                            <template v-else>
                                <div class="list">
                                    <i class="icon-coffee"></i>
                                    <div>
                                        <div class="f7">
                                            I have been known to enjoy Sunday Brunch at
                                        </div>
                                        <div  class="text-bold">
                                            {{dap.geo.city}}, {{dap.geo.state}}
                                        </div>
                                    </div>

                                    <i class="icon-walking"></i>
                                    <div>
                                        <div class="f7">
                                            You might find me walking at
                                        </div>
                                        <div class="text-bold">
                                         {{dap.geo.city}}, {{dap.geo.state}}
                                        </div>
                                    </div>
                                </div>
                            </template>
                       </div>
                   </div>
                </div>
            </div>
            <agentTransactionDetail :agentId="dap.agentId"></agentTransactionDetail>
            <brokerageNearby v-if="dap.transactions" :agentId="dap.agentId"></brokerageNearby>
            <div class="static-section" v-if="dap.reviews && dap.reviews.length">
                <div class="static-gs gs-md-fix">
                    <agentReview :reviews="dap.reviews"></agentReview>
                    <div>
                        <div class="dap-notice">
                            <div class="f4">
                                <b>
                                    {{dap.firstName}}’s Review & Ratings
                                </b>
                            </div>
                            <div class="info">
                                <div class="f7">
                                    <span>{{dap.averageRating}}/5</span>
                                    <template v-for="index in 5">
                                        <i class="icon-star" v-if="dap.averageRating - index >= 0"></i>
                                        <i class="icon-star-half" v-else-if="dap.averageRating - index > -1"></i>
                                        <i class="icon-star-o" v-else></i>
                                    </template>
                                </div>
                                <div class="f8">{{dap.reviewCount}} Reviews</div>
                            </div>
                            <div class="list">
                                <div>5 Star </div>
                                <div class="dap-bar">
                                    <div :style="{width:reviewSummary.star5per+'%'}"></div><div></div>
                                </div>

                                <div>4 Star</div>
                                <div class="dap-bar">
                                    <div :style="{width:reviewSummary.star4per+'%'}"></div><div></div>
                                </div>

                                <div>3 Star</div>
                                <div class="dap-bar">
                                    <div :style="{width:reviewSummary.star3per+'%'}"></div><div></div>
                                </div>

                                <div>2 Star</div>
                                <div class="dap-bar">
                                    <div :style="{width:reviewSummary.star2per+'%'}"></div><div></div>
                                </div>

                                <div>1 Star</div>
                                <div class="dap-bar">
                                    <div :style="{width:reviewSummary.star1per+'%'}"></div><div></div>
                                </div>
                            </div>
                            <div>
                                <button @click="openHotlead" class="btn primary regular">Contact {{dap.firstName}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="static-section" v-if="getShowList('new', 'city')">
                <div class="static-gs">
                    <div class="f3 text-center">
                        <a class="link text-bold" :href="getMSPlink">
                            {{molang('dpp.seo.new')}} <span class="hidden-xs">in {{dap.geo.city}}</span>
                        </a>
                    </div>
                        <mvtLazyload ref="lazyloadNew" data-role="propertycard">
                          <mvtNearby type="city" filterPath="/new-7/" @completed="completedNew" carousalType="new"></mvtNearby>
                        </mvtLazyload>
                </div>
            </div>

            <brokerageBanner class="inline large bg-default" ></brokerageBanner>
            <agentBrokerage  id="agentBrokeragePanel" class="inline large"></agentBrokerage>
            <agentRegion class="inline large" :cities="dap.cities" :counties="dap.counties"/>
            <mvtFooter />
            <mvtDialog ref="review" @hidden="hideReview" v-ga:dialog>
                <div class="agent-review">
                    <div v-if="dap">
                        <mvtCardAgent :simple="true" :data="dap"></mvtCardAgent>
                        <div class="text-center f4"><b>Write a review for {{dap.firstName}}</b></div>
                        <div class="text-center text-gray">How likely are you to recommend {{dap.firstName}}</div>
                    </div>

                    <form v-submit="submitReview">
                        <mvtTextbox>
                            <div class="input selectRadio">
                                <mvtRating v-validate="'required|rating'" v-model="review.rating"></mvtRating>
                            </div>
                        </mvtTextbox>
                        <div class="form form-default">
                            <div class="form-input">
                                <mvtTextbox>
                                    <div class="input">
                                        <label>{{ molang('search.common.reviewTitle') }}</label>
                                        <input
                                            ref="reviewTitle"
                                            type="text"
                                            name="reviewTitle"
                                            v-inputtrim
                                            v-validate="'required|reviewTitle'"
                                            v-model="review.title"
                                            maxlength="128"
                                        />
                                    </div>
                                </mvtTextbox>
                                <mvtTextbox class="comments">
                                    <div class="input textarea">
                                        <label>Describe in detail your experience</label>
                                        <textarea name="comment" v-model="review.comment" maxlength="4000"></textarea>
                                    </div>
                                </mvtTextbox>
                                <mvtTextbox>
                                    <div class="input selectData">
                                        <mvtSelect :data="serviceData" v-validate="'required|serviceProvided'" v-model="review.service" />
                                    </div>
                                </mvtTextbox>
                                <mvtTextbox>
                                    <div class="input selectData">
                                        <mvtSelect :data="yearData" v-validate="'required|yearPurchased'" v-model="review.year" />
                                    </div>
                                </mvtTextbox>
                                <mvtTextbox>
                                    <mvtInputGeo v-validate="'required|address'" :isShowLabel="true" :hideButton="true" :placeholder="molang('search.common.reviewPropertyAddress')" v-model="review.address"/>
                                </mvtTextbox>
                            </div>
                            <mvtCheckbox class="show-city" v-model="review.showCityState" :data="showCityStateData" :wrap="false"></mvtCheckbox>
                            <button class="btn primary regular" type="submit">Post Review</button>
                        </div>
                    </form>
                </div>
            </mvtDialog>
            <mvtDialog ref="report" @hidden="hideReport" v-ga:dialog>
                <div class="agent-report">
                    <div>
                        <div class="text-center f4"><b>Report Abuse</b></div>
                        <div class="text-center text-gray">Please enter the details of your request. A member of our support staff will respond as soon as possible.</div>
                    </div>

                    <form v-submit="submitReport">
                        <div class="form form-default">
                            <mvtTextbox>
                                <div class="input">
                                    <label>{{ molang('search.common.email') }}</label>
                                    <input
                                        type="email"
                                        name="email"
                                        v-model="report.email"
                                        maxlength="128"
                                        autocomplete="email"
                                        v-inputtrim
                                        v-validate="'required|email'"
                                    />
                                </div>
                            </mvtTextbox>
                            <mvtTextbox>
                                <div class="input">
                                    <label>{{ molang('search.common.subject') }}</label>
                                    <input
                                        type="text"
                                        name="subject"
                                        v-model="report.subject"
                                        v-validate="'required|subject'"
                                    />
                                </div>
                            </mvtTextbox>
                            <mvtTextbox class="comments" v-if="glb.isMobile">
                                <div class="input textarea">
                                    <label>{{ molang('search.common.description') }}</label>
                                    <textarea name="description" v-validate="'required|description'" v-model="report.description" maxlength="4000"></textarea>
                                </div>
                            </mvtTextbox>
                            <button class="btn primary regular" type="submit">Send Request</button>
                        </div>
                    </form>
                </div>
            </mvtDialog>
            <mvtDialogCenter></mvtDialogCenter>
            <mvtToastCenter />
        </div>
    </div>
</template>
<script src="./page-dap.js"></script>
<style lang="scss">
@use "./page-dap.scss" as *;
</style>